import { ng } from '@uirouter/angularjs/lib/angular';
import { StateService } from '@uirouter/core';
import * as angular from 'angular';
import { ngStorage } from 'ngstorage';
import { NotificationService } from '../../../../../app.common/modules/common/services/notification.service';
import { ProductsService } from '../../../products/products.service';
import {
    IBundleComponentItem,
    IBundleComponentItemWithProducts,
    IBundleItem,
    ICreateBundleRequest
} from '../../models/models';
import { BundlesService } from '../../services/bundles.service';

class NewEditBundleComponent {
    public static $inject = [
        '$localStorage',
        'notificationService',
        'bundlesService',
        '$state',
        '$translate',
        'productsService'
    ];

    public waiting = false;
    public isNew: boolean;
    public bundleID: number;
    public bundle: IBundleItem;
    public form: ng.IFormController;

    private defaultBundle: IBundleItem = {
        Components: [{
            Name: null,
            Quantity: 1,
            Variations: []
        }],
        Description: null,
        LogoImageID: null,
        Name: null,
        BundleValue: {
          Price: null,
          DiscountPercent: null
        },
        ValidFrom: null,
        ValidTo: null,
        ID: null
    };

    private originalBundle: IBundleItem;

    constructor(
        private $localStorage: ngStorage.StorageService,
        private notificationService: NotificationService,
        private bundlesService: BundlesService,
        private $state: StateService,
        private $translate: angular.translate.ITranslateService,
        private productService: ProductsService
    ) {
    }

    public async $onInit() {
        const id = parseInt(this.$state.params.id, 10);
        this.isNew = isNaN(id);
        if (!this.isNew) {
            this.bundleID = id;
            await this.loadData();
        } else {
            this.bundle = {...this.defaultBundle};
        }
    }

    public isBundleValid(): boolean {
        const logoCorrect = this.bundle.LogoImageID != null;
        const correctComponentFound = this.bundle.Components.find((item) => !!item.Name && item.Variations.length > 0) != null;
        const noComponentWithErrors = this.bundle.Components.length > 0 && this.bundle.Components.find((item) => !this.isValidComponent(item)) == null;
        const formValid = this.form.$valid && this.bundle.Name &&
            (this.bundle.BundleValue.Price || this.bundle.BundleValue.DiscountPercent)
            && this.bundle.Description;
        return formValid && logoCorrect && noComponentWithErrors && correctComponentFound;
    }

    public async save() {
        if (!this.validForSave()) {
            this.notificationService.showErrorMessage(this.$translate.instant('form_has_errors'));
            return;
        }
        this.waiting = true;
        this.notificationService.showWaitingMessage();
        try {
            if (!this.isNew && this.originalBundle.LogoImageID !== this.bundle.LogoImageID) {
                await this.bundlesService.removeLogoImage(this.originalBundle.LogoImageID);
            }
            const savingBundle = this.getSavingBundle();
            this.isNew ? await this.bundlesService.createBundle(savingBundle) : await this.bundlesService.updateBundle(this.bundleID, savingBundle);
            this.notificationService.showSuccessMessage();
            this.waiting = false;
            this.$state.go('app.bundles');
        } catch (error) {
            this.waiting = false;
            this.notificationService.showErrorMessage(error);
        }
    }

    public restore() {
        const bundleToRestore = this.isNew ? {...this.defaultBundle} : {...this.originalBundle};
        this.bundle = angular.copy(bundleToRestore);
        if (this.form) {
            this.form.$setPristine();
            this.form.$setUntouched();
        }
    }

    private async loadData() {
        if (this.waiting) {
            return;
        }
        this.waiting = true;
        this.notificationService.showWaitingMessage();
        try {
            const metadata = await this.productService.getMetadata();
            this.originalBundle = await this.bundlesService.getBundle(this.bundleID);
            this.bundlesService.fillSizeAndColourNames(this.originalBundle, metadata);
            this.restore();
            this.notificationService.clearAll();
            this.waiting = false;
        } catch (error) {
            this.notificationService.showErrorMessage(error);
            this.waiting = false;
        }
    }

    private validForSave(): boolean {
        if (this.waiting || !this.isBundleValid()) {
            return false;
        }
        return this.bundle.Components.reduce((checkValue, component) => {
            component.errors = {
                name: !component.Name,
                noVariations: component.Variations.length === 0
            };
            return checkValue && this.isValidComponent(component);
        }, true);
    }

    private isValidComponent(component: IBundleComponentItemWithProducts): boolean {
        return !(component.errors &&
                    (component.errors.name ||
                     component.errors.noVariations));
    }

    private getSavingBundle(): ICreateBundleRequest {
        return {
            Name: this.bundle.Name,
            LogoImageID: this.bundle.LogoImageID,
            BundleValue: {
              Price: this.bundle.BundleValue.Price,
              DiscountPercent: this.bundle.BundleValue.DiscountPercent
            },
            Description: this.bundle.Description,
            ValidTo: this.bundle.ValidTo ? this.bundle.ValidTo : null,
            ValidFrom: this.bundle.ValidFrom ? this.bundle.ValidFrom : null,
            Components: this.bundle.Components.map((component) => {
                return {
                    Name: component.Name,
                    Quantity: component.Quantity,
                    VariationIDs: component.Variations.map((variation) => variation.VariationID)
                } as IBundleComponentItem;
            })
        } as ICreateBundleRequest;
    }

}

angular.module('naut').component('newEditBundleComponent', {
    template: require('./new-edit-bundle.component.html'),
    controller: NewEditBundleComponent,
    controllerAs: 'ctrl'
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/bundles/components/new-edit-bundle/new-edit-bundle.component.ts